/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Member_Login_Method_Sso_EmailInputs */



/**
* | output |
* | --- |
* | "{provider} address" |
*
* @param {Member_Login_Method_Sso_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_method_sso_email = /** @type {((inputs: Member_Login_Method_Sso_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Method_Sso_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.provider}-Adresse`)
	return /** @type {LocalizedString} */ (`${i?.provider} address`)
});